<!-- not found -->
<div class="no-found" *ngIf="inputNotFound.visible">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">

        <p>{{ (inputNotFound?.message || '') | translate }}</p>

    </div>
</div>
